// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsents_root__36uQO","consentsList":"PatientConsents_consentsList__1wSQk","consentsListEmpty":"PatientConsents_consentsListEmpty__2od1-"};